module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/airplay-7eecb72ecae18ac211d9bca4993d02bf.svg";